import { startOfDay, endOfDay } from 'date-fns';
import { put, call, select, takeLatest } from 'redux-saga/effects';
import { API } from 'services/api/base';
import { selectors as clientSelectors } from 'store/clients';
import { types, GetSalesByKioskRequest, KioskSales } from './types';

export function* getSalesByKioskAsync({ payload }: GetSalesByKioskRequest) {
  yield put({ type: types.GET_SALES_BY_KIOSK.PENDING, payload: true });

  try {
    const clientId: string = yield select(clientSelectors.selectClientId);

    const api = new API(`clients/${clientId}/salesByKiosk`);

    const response: KioskSales[] = yield call(api.getAll, {
      startDate: startOfDay(new Date(`${payload.startDate}T00:00:00`)).toISOString(),
      endDate: endOfDay(new Date(`${payload.endDate}T00:00:00`)).toISOString()
    });

    yield put({ type: types.GET_SALES_BY_KIOSK.SUCCESS, payload: response });
  } catch (err) {
    yield put({ type: types.GET_SALES_BY_KIOSK.ERROR, payload: 'Something went wrong getting kiosk sales' });
  } finally {
    yield put({ type: types.GET_SALES_BY_KIOSK.PENDING, payload: false });
  }
}

export const sagas = [takeLatest(types.GET_SALES_BY_KIOSK.REQUEST, getSalesByKioskAsync)];
